export default __webpack_public_path__ + "icons/white.svg";